import React from 'react';
import { useIntl } from 'react-intl-next';
import { TopicsSection, Title } from 'view/styles/help-center';
import { Loader, Topics, Topic, HelpObjects, HelpObject, Icon, HelpObjectLink } from './styled';
import { useLastLoadedTopicsCount } from '../use-last-loaded-topics-count';
import messages from '../topics/messages';
import TopicsRoot from 'view/common/topics-root';

export const TopicsLoader = () => {
    const { count } = useLastLoadedTopicsCount();
    const { formatMessage } = useIntl();
    if (count < 1) return null;
    return (
        <TopicsRoot>
            <Title>{formatMessage(messages.topicsSectionLabel)}</Title>
            <TopicsSection count={count}>
                <Topics count={count}>
                    {Array.from({ length: count }, (_, i) => (
                        <Topic key={i}>
                            <Loader height={24} />
                            <HelpObjects>
                                {Array.from({ length: 3 }, (_n, j) => (
                                    <HelpObject key={j}>
                                        <Icon>
                                            <Loader height={21} />
                                        </Icon>
                                        <HelpObjectLink>
                                            <Loader height={21} />
                                        </HelpObjectLink>
                                    </HelpObject>
                                ))}
                            </HelpObjects>
                        </Topic>
                    ))}
                </Topics>
            </TopicsSection>
        </TopicsRoot>
    );
};
